
























import { Component, Vue } from "vue-property-decorator";
import Constants from "../../shared/constants";
import { getModule } from "vuex-module-decorators";
import NavSidebarStore from "../../store/nav-sidebar.store";
import sidebarMenu from "./_nav";

@Component
export default class NavSidebar extends Vue {
  private readonly websiteName = Constants.WEBSITE_NAME;
  private readonly navSidebarStore: NavSidebarStore = getModule(
    NavSidebarStore,
    this.$store
  );
  get nav() {
    return sidebarMenu;
  }
  get sidebarShow() {
    return this.navSidebarStore.getSidebarShow;
  }
  get sidebarMinimize() {
    return this.navSidebarStore.getSidebarMinimize;
  }
  private onSidebarUpdate(value: string | boolean) {
    this.navSidebarStore.setSidebarShow(value);
  }
  private onSidebarMinimizerClick() {
    this.navSidebarStore.setSidebarMinimize(!this.sidebarMinimize);
  }
}
